import uuid from 'node-uuid';
import "./Tile";
import "./OL3/Yandex";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 * @extends GIS.Map.Layer.Tile
 *
 * todo implement through Yandex API
 */
GIS.Map.Layer.Yandex = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.Yandex.prototype */ {
    vendor: {
        'ol3': GIS.Map.Layer.OL3.Yandex
    },
    title: 'Yandex Tiles',
    attributions: ["Картографические данные © Яндекс, 2015"],
    maxZoom: 18,
    layerName: 'sat',
    projection: 'EPSG:3395',
    l: null,
    urlParams: ["layerName", "tileFormat", "l"],
    url: 'http://{layerName}0{1-4}.maps.yandex.net/tiles?l={l}&v=4.47.1&x={x}&y={y}&z={z}&lang=ru_RU',
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.Yandex:" + uuid.v4();
    }
});


//        /**
//         * @class
//         * @extends GIS.Map.Layer.Tile
//         * @todo implement through Yandex API
//         * @todo rewrite with using of new Tile layer API
//         */
//        GIS.Map.Layer.YandexSatellite = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.YandexSatellite.prototype */{
//            maxZoom: 18,
//            url: "http://sat0{0-4}.maps.yandex.net/tiles?l=sat&v=3.216.0&x={x}&y={y}&z={z}&lang=ru_RU",
//            attributions: ["Картографические данные © Яндекс, 2015"],
//            /** @inheritDoc */
//            prepareOptions: function(options) {
//                this.Parent(options);
//
//                _.merge(options, {
//                    projection: new YandexProjection()
//                });
//            }
//            //initialize: function(map, options) {
//            //    var self = this;
//            //
//            //    options || (options = {});
//            //
//            //    options.options = _.merge(options.options || {}, {
//            //        projection: new YandexProjection(),
//            //        maxZoom: 18,
//            //        url: "http://sat0{0-4}.maps.yandex.net/tiles?l=sat&v=3.216.0&x={x}&y={y}&z={z}&lang=ru_RU",
//            //        attributions: ["Картографические данные © Яндекс, 2015"]
//            //    });
//            //
//            //    this.Parent(map, options);
//            //
//            //    this.map.map.removeLayer(this.layer.layer);
//            //    this.layer.layer = new ol.layer.Group({
//            //        layers: [this.layer.layer]
//            //    });
//            //    this.map.map.addLayer(this.layer.layer);
//            //
//            //    this.layer.layer.getLayers().push(this.layer.createLayer({
//            //        projection: new YandexProjection(),
//            //        maxZoom: 18,
//            //        url: "http://vec0{0-4}.maps.yandex.net/tiles?l=skl&v=3.216.0&x={x}&y={y}&z={z}&lang=ru_RU"
//            //    }));
//            //}
//        });
//
//        proj4.defs("EPSG:3395", "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");
//        var epsg3395 = ol.proj.get("EPSG:3395");
//        /**
//         * Custom Yandex projection
//         * Inherits EPSG:3857 project with another extent
//         * (Temp helper projection. Yandex uses an equivalent of EPSG:3395 project, but
//         * ol3 in current release doesn't support reprojection of raster layers)
//         *
//         * @param options
//         * @constructor
//         * @extends ol.proj.Projection
//         */
//        function YandexProjection(options) {
//            options || (options = {});
//
//            ol.proj.Projection.prototype.constructor.call(this, _.merge(options, {
//                code: "YaProj",
//                units: epsg3395.getUnits(),
//                extent: [-20037508, -20002151, 20037508, 20072865],
//                global: true,
//                worldExtent: [-180, -85, 180, 85]
//            }));
//
//            ol.proj.addCoordinateTransforms("EPSG:4326", this, ol.proj.getTransform("EPSG:4326", epsg3395), ol.proj.getTransform(epsg3395, "EPSG:4326"));
//            //ol.proj.addCoordinateTransforms("EPSG:4326", this, function(input, opt_output, opt_dimension) {
//            //    var length = input.length,
//            //        dimension = opt_dimension > 1 ? opt_dimension : 2,
//            //        output = opt_output;
//            //
//            //    if (!Util.isDefined(output)) {
//            //        if (dimension > 2) {
//            //            // preserve values beyond second dimension
//            //            output = input.slice();
//            //        } else {
//            //            output = new Array(length);
//            //        }
//            //    }
//            //
//            //    assert(output.length % dimension === 0);
//            //
//            //    for (var i = 0; i < length; i += dimension) {
//            //        output[i] = YandexProjection.RADIUS * Math.PI * input[i] / 180;
//            //        output[i + 1] = YandexProjection.RADIUS * Math.log(Math.tan(Math.PI * (input[i + 1] + 90) / 360));
//            //    }
//            //
//            //    return output;
//            //}, function(input, opt_output, opt_dimension) {
//            //    var length = input.length,
//            //        dimension = opt_dimension > 1 ? opt_dimension : 2,
//            //        output = opt_output;
//            //
//            //    if (!Util.isDefined(output)) {
//            //        if (dimension > 2) {
//            //            // preserve values beyond second dimension
//            //            output = input.slice();
//            //        } else {
//            //            output = new Array(length);
//            //        }
//            //    }
//            //
//            //    assert(output.length % dimension === 0);
//            //
//            //    for (var i = 0; i < length; i += dimension) {
//            //        output[i] = 180 * input[i] / (YandexProjection.RADIUS * Math.PI);
//            //        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / YandexProjection.RADIUS)) / Math.PI - 90;
//            //    }
//            //
//            //    return output;
//            //});
//        };
//
//        ol.inherits(YandexProjection, ol.proj.Projection);
//
//        //YandexProjection.RADIUS = 6378137;
//
//        YandexProjection.prototype.getPointResolution = function(resolution, point) {
//            return ol.proj.get("EPSG:3857").getPointResolution(resolution, point);
//        };
